import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getServices = async () => {
  const { data } = await axios.get(`${API}/services`);
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await axios.post(`${API}/bookings`, payload);
  return data;
};

export const createCheckout = async (bookingId) => {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    booking_id: bookingId,
    origin_url: window.location.origin,
  });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
};
